import React from 'react';
import { PDP_CONFIG } from '../config/ztaArchitectureData';
import CapabilityModal from './ZtaCapabilityModal';
import GovernanceModal from './ZtaGovernanceModal';
import SignalModal from './ZtaSignalModal';
import PDPModal from './ZtaPdpModal';
import VisibilityToolModal from './ZtaVisibilityToolModal';

// Modal host — renders whichever edit modal is open (capability, governance,
// signal, PDP, visibility tool). State stays owned by the container.
const ZtaModals = ({
  selectedDepartment,
  suggestionModeEnabled,
  editingCapability,
  setEditingCapability,
  editingGovernance,
  setEditingGovernance,
  editingSignal,
  setEditingSignal,
  editingPDP,
  setEditingPDP,
  editingVisibilityTool,
  setEditingVisibilityTool,
  pdpData,
  // Per-save-kind pending flags from useZtaDepartmentData —
  // { capability, governance, signal, pdp }. Each modal gets only its own.
  saving,
  getCapabilityState,
  getGovernanceState,
  getSignalState,
  getSuggestion,
  getCapabilitySuggestion,
  saveCapability,
  saveGovernance,
  saveSignal,
  savePDP,
}) => {
  return (
    <>
      {/* Capability Edit Modal */}
      {editingCapability && (
        <CapabilityModal
          capability={editingCapability}
          data={getCapabilityState(editingCapability.id)}
          suggestion={suggestionModeEnabled ? getCapabilitySuggestion(editingCapability.id) : null}
          onClose={() => setEditingCapability(null)}
          onSave={(data) => {
            saveCapability(editingCapability.id, data);
            setEditingCapability(null);
          }}
          saving={!!saving?.capability}
          departmentName={selectedDepartment?.common_name || selectedDepartment?.acronym}
          departmentId={selectedDepartment?.department_id}
        />
      )}

      {/* Governance Modal */}
      {editingGovernance && (
        <GovernanceModal
          item={editingGovernance}
          data={getGovernanceState(editingGovernance.id)}
          onClose={() => setEditingGovernance(null)}
          onSave={(data) => {
            saveGovernance(editingGovernance.id, data);
            setEditingGovernance(null);
          }}
          saving={!!saving?.governance}
          departmentSelected={!!selectedDepartment}
          departmentName={selectedDepartment?.common_name || selectedDepartment?.acronym}
        />
      )}

      {/* Signal Modal */}
      {editingSignal && (
        <SignalModal
          signal={editingSignal}
          data={getSignalState(editingSignal.id)}
          suggestion={suggestionModeEnabled ? getSuggestion(editingSignal.id) : null}
          onClose={() => setEditingSignal(null)}
          onSave={(data) => {
            saveSignal(editingSignal.id, data);
            setEditingSignal(null);
          }}
          saving={!!saving?.signal}
          departmentSelected={!!selectedDepartment}
          departmentId={selectedDepartment?.department_id}
          departmentName={selectedDepartment?.common_name || selectedDepartment?.acronym}
        />
      )}

      {/* PDP Modal */}
      {editingPDP && (
        <PDPModal
          config={PDP_CONFIG}
          data={pdpData}
          onClose={() => setEditingPDP(false)}
          onSave={(data) => {
            savePDP(data);
            setEditingPDP(false);
          }}
          saving={!!saving?.pdp}
          departmentSelected={!!selectedDepartment}
          departmentName={selectedDepartment?.common_name || selectedDepartment?.acronym}
        />
      )}

      {/* Visibility Tool Modal */}
      {editingVisibilityTool && (
        <VisibilityToolModal
          tool={editingVisibilityTool}
          data={getCapabilityState(editingVisibilityTool.id)}
          suggestion={suggestionModeEnabled ? getCapabilitySuggestion(editingVisibilityTool.id) : null}
          onClose={() => setEditingVisibilityTool(null)}
          onSave={(data) => {
            saveCapability(editingVisibilityTool.id, data);
            setEditingVisibilityTool(null);
          }}
          saving={!!saving?.capability}
          departmentName={selectedDepartment?.common_name || selectedDepartment?.acronym}
          departmentId={selectedDepartment?.department_id}
        />
      )}
    </>
  );
};

export default ZtaModals;
